// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3sIKX","label":"Completed_label__69BNK"};